import React, { useState, useEffect } from "react";
import {  FormLabel } from '@mui/material';
import Dropzone, { Accept } from 'react-dropzone';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Api from "../../../network/Api";
import TypingIndicator from "../../Shared/TypingIndicator";

type UploaderProps = {
  accept: Accept;
  onUploaded: () => void;
}

export type FileResponse = {
  id: string,
  name: string
}

const Uploader = (props: UploaderProps) => {

  const [file, setFile] = useState<File>();
  const [isUploading, shouldUpload] = useState(false);

  useEffect(() => {
    if (typeof(file) === "undefined") { return }
    shouldUpload(true);
    Api.upload("/uploads", file, {}).then(result => {
      shouldUpload(false);
      props.onUploaded();
    })
  }, [file]);

  return <>
    <Dropzone 
      accept={props.accept}
      multiple={false} 
      maxFiles={1}
      disabled={isUploading}
      onDrop={acceptedFiles => setFile(acceptedFiles[0])}>
      {({getRootProps, getInputProps}) => (
        <div className='file-dropzone' {...getRootProps()}>
          <input {...getInputProps()} />
          { isUploading ? <>
            <TypingIndicator />
            <FormLabel>Uploading <strong>{file?.path}</strong> ...</FormLabel>
          </> : <>
            <FormLabel>Click to select, or drag'n'drop <strong>{Object.entries(props.accept).map(([key, values]) => {
              return values;
            })}</strong> file.</FormLabel>
            <UploadFileIcon fontSize="large" className="text-secondary" />
          </> }
        </div>
      )}
    </Dropzone>
  </>
}

export default Uploader;